import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 48px 24px 64px;

  @media (max-width: 800px) {
    padding: 32px 16px 48px;
  }
`;

export const PageTitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

export const Title = styled.h1`
  font-size: 22px;
  ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.shaft};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 12px;
`;

export const TitleAccent = styled.div`
  width: 48px;
  height: 2px;
  background: ${({ theme }) => theme.colors.gulfStream};
  margin: 0 auto;
`;

export const Accordion = styled.div`
  cursor: pointer;
  padding: 20px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.mercury};
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.75;
  }
`;

export const AccordionHeader = styled.span`
  font-size: 17px;
  color: ${({ theme }) => theme.colors.matterhorn};
  ${({ theme }) => theme.fonts.semiBold};
  line-height: 1.4;
  padding-right: 16px;
`;

export const AccordionValue = styled.span`
  font-size: 15px;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.gray};
  ${({ theme }) => theme.fonts.regular};
  display: block;
`;

export const MotionContainer = styled(motion.div)`
  padding-top: 12px;
  display: grid;
`;
